import { useIntl } from 'react-intl'
import { Link } from 'react-router-dom'

type Props = {
  id: string
}

export const BecomeAnExpert = ({ id }: Props) => {
  const { formatMessage } = useIntl()

  return (
    <section id={id} className="py-[100px] px-4 xl:px-[91px] bg-[#4A7D9A]">
      <div className="flex flex-col items-center text-justify max-w-[1264px] mx-auto">
        <h2 className="text-2xl md:text-[36px] leading-[60px] mb-10 text-center uppercase font-openSans text-[#BAF5F5] font-bold">
          {formatMessage({ id: 'BECOME_AN_EXPERT' })}
        </h2>
        <div className="text-white md:leading-9 md:text-2xl text-base font-normal font-montserrat mb-10">
          <p>
            {formatMessage({ id: 'BECOME_AN_EXPERT_TEXT' })}
          </p>
        </div>
        <Link
          className="font-openSans text-center text-base leading-[24px] h-12 py-3 px-6 font-semibold uppercase bg-white rounded-lg whitespace-nowrap hover:bg-[#BAF5F5] shadow-[0px_6px_4px_0px_rgba(224,224,224,0.20)]"
          to="/expert"
          target='_blank'
        >
          {formatMessage({ id: 'BECOME_AN_EXPERT' })}
        </Link>
      </div>
    </section>
  )
}
